<div class="container">
  <form nz-form [formGroup]="form" class="form">
    <nz-form-item>
      <div class="in-row">
        <div class="title">{{ "order.renewal_days" | translate }}</div>
        <nz-form-control class="text">
          <host-input-with-error
            [showError]="
              checking &&
              (!form.get('days').value || form.get('days').value === '')
            "
            errorText="{{ 'errorText.renewal_days_required' | translate }}"
          >
            <nz-input-number
              class="w-90"
              formControlName="days"
              [nzStep]="1"
              [nzMin]="1"
              [nzPrecision]="0"
              nzPlaceHolder="{{ 'placeholder.days_required' | translate }}"
            >
            </nz-input-number>
          </host-input-with-error>
        </nz-form-control>
        <span class="day">{{
          (form.get("days").value > 1 ? "word.days" : "word.day") | translate
        }}</span>
      </div>
    </nz-form-item>

    <nz-form-item>
      <div class="in-row">
        <div class="title">{{ "order.catch_up_house_fee" | translate }}</div>
        <nz-form-control class="text">
          <host-input-with-error
            [showError]="
              checking &&
              (!form.get('needFee').value || form.get('needFee').value === '')
            "
            errorText="{{
              'errorText.catch_up_house_fee_required' | translate
            }}"
          >
            <nz-input-number
              class="w-150"
              [nzStep]="1"
              [nzMin]="0"
              [nzMax]="maxAmount"
              nzPlaceHolder="{{ 'order.house_fee' | translate }}"
              formControlName="needFee"
            >
            </nz-input-number>
          </host-input-with-error>
        </nz-form-control>
      </div>
    </nz-form-item>
    <!-- <nz-form-item>
      <nz-form-control class="checked">
        <label
          nz-checkbox
          formControlName="checked"
          (ngModelChange)="getCheckedChange()"
          >已到账</label
        >
      </nz-form-control>
    </nz-form-item> -->
    <nz-form-item>
      <div class="in-row">
        <div class="title">{{ "order.collected_house_fee" | translate }}</div>
        <nz-form-control class="text">
          <!-- <host-input-with-error
            [showError]="
              checking &&
              (!form.get('paid_amount').value ||
                form.get('paid_amount').value === '')
            "
            [errorText]="'请填写已收房款'"
          > -->
          <nz-input-number
            class="w-150"
            [nzStep]="1"
            [nzMin]="0"
            [nzMax]="maxAmount"
            nzPlaceHolder="{{ 'order.collected_house_fee' | translate }}"
            formControlName="paid_amount"
          >
          </nz-input-number>
          <!-- </host-input-with-error> -->
        </nz-form-control>
      </div>
    </nz-form-item>
    <nz-form-item class="in-row">
      <div class="title">{{ "word.payment_method" | translate }}</div>
      <nz-form-control class="text">
        <nz-select formControlName="trade" class="w-150">
          <nz-option
            *ngFor="let option of payOptions"
            [nzValue]="option.code"
            [nzLabel]="option.method_name"
          ></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </form>
</div>
<div class="footer">
  <div class="button">
    <button nz-button nzType="primary" (click)="save()">
      {{ "word.save" | translate }}
    </button>
  </div>
  <div class="button">
    <button nz-button nzType="default" (click)="cancel()">
      {{ "word.cancel" | translate }}
    </button>
  </div>
</div>
